export default "__VITE_ASSET__CaUKhm3$__"